import React, { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { useDropoffPatternsQuery } from '@src/services/queries';
import SpinContainer from '@shared/components/SpinContainer';
import { Sankey } from '@src/pages/journey-map/components';
import { generateSankeyData } from '@src/pages/journey-map/utils/generateSankeyData';
import getSankeySize from '@src/pages/journey-map/utils/getSankeySize';
import { usePatternQueryPayload, checkPropagationStepDropoffAvailable } from '../../utils';
import * as store from '../../store';

const DropoffJourney = () => {
  const [{ limit: _limit, ...payload }, { pattern }] = usePatternQueryPayload();
  const dropoffIndex = useAtomValue(store.dropOffIndexAtom);
  const { data, isFetching } = useDropoffPatternsQuery(
    {
      ...payload,
      dropoff_index: dropoffIndex,
    },
    {
      enabled: checkPropagationStepDropoffAvailable(dropoffIndex, payload.filters),
    },
  );

  const sankeyData = useMemo(() => generateSankeyData(data ?? [], false, true), [data]);
  const { width, height } = useMemo(() => getSankeySize(sankeyData, 'left'), [sankeyData]);

  return (
    <SpinContainer
      autoHeight
      spinning={isFetching}
      empty={!sankeyData.links.length && { type: 'chart', message: 'No data' }}
    >
      <Sankey
        data={sankeyData}
        highlightedNodes={pattern.length > 0 ? pattern : []}
        width={width}
        height={height}
        align={'left'}
      />
    </SpinContainer>
  );
};

export default DropoffJourney;
